import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase/client';

export interface Infographie {
  id: string;
  title: string;
  slug: string;
  description: string;
  image_url: string;
  category: string;
  tags: string[];
  view_count: number;
  download_count: number;
  status: string;
  published_at: string;
  created_at: string;
  updated_at: string;
}

export function useInfographies() {
  const [infographies, setInfographies] = useState<Infographie[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function fetchInfographies() {
      try {
        setLoading(true);
        const { data, error: fetchError } = await supabase
          .from('infographies')
          .select('*')
          .eq('status', 'published')
          .order('published_at', { ascending: false });

        if (fetchError) throw fetchError;
        setInfographies(data || []);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    }

    fetchInfographies();
  }, []);

  return { infographies, loading, error };
}
